import React from 'react'

function Loader() {
    return (
        <div className='spinner-border text-primary' role='status'>
                            
        </div>
    )
}

export default Loader